var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup166(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 287,
    viewBox: "0 0 287 287",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M286.536 143.268C286.536 222.397 222.397 286.536 143.268 286.536C64.1506 286.536 0 222.397 0 143.268C0 64.1506 64.1506 0 143.268 0C222.397 0 286.536 64.1506 286.536 143.268Z",
    fill: "#6D31ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.928 148.686L62.291 194.744V90.9702L124.928 148.686Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M220.061 196.031H64.9834L126.906 150.503L141.603 164.043C142.111 164.508 142.944 164.508 143.441 164.043L158.149 150.503L220.061 196.031Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M222.755 90.9702V194.744L160.118 148.686L222.755 90.9702Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M220.7 89.2831L157.177 147.821C157.166 147.832 157.155 147.843 157.144 147.854L142.523 161.317L127.913 147.854C127.902 147.843 127.892 147.832 127.87 147.821L64.3467 89.2831H220.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup166);
export default __webpack_public_path__ + "static/media/Group 166.2f7e82d6963044192c95f76ea38a6ff2.svg";
export { ForwardRef as ReactComponent };